var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-warning"},[_c('p',[_vm._v("The website is temporarily unavailable for mobile access."),_c('br'),_c('br'),_vm._v("©Huliawsl 2025")])])
}]

export { render, staticRenderFns }